import './style/big-service-tab.css';
import { connect } from 'react-redux';
import { useEffect, useRef, useState } from 'react'
import { fetchEmployees, fetchCategoryReviews } from '../../../actions'
import { Link } from 'react-router-dom';

import Accordian from '../../utils/Accordian';
import { BASE_URL } from '../../../variables';
import SingleReview from './SingleReview';
import CreateReview from '../Components/createReview';
import { CategoryContext } from './context'


import image1 from '../../../images/how-it-work1-grey.svg';
import image2 from '../../../images/how-it-work2-grey.svg';
import image3 from '../../../images/how-it-work3-grey.svg';

import image1_blue from '../../../images/how-it-work1-blue.svg';
import image2_blue from '../../../images/how-it-work2-blue.svg';
import image3_blue from '../../../images/how-it-work3-blue.svg';


const BigServiceTab = (props) => {
    const [replyActiveFor, setReplyActiveFor] = useState(null)
    const {fetchEmployees, fetchCategoryReviews, category, currentTheme} = props
    const scrolableRef = useRef()
    useEffect(() => {
        fetchEmployees(category)
        fetchCategoryReviews(category)
    }, [fetchEmployees, category,fetchCategoryReviews])

    const toggleReplyForm = (reply_id) => {
        const value = replyActiveFor === reply_id ? null : reply_id
        setReplyActiveFor(value)
    }

    const activateTab = (e) => {
        Array.from(e.target.parentNode.children).forEach(element => {
            element.classList.remove('active')
        })
        
        e.target.classList.add('active')
        const active_content = document.getElementById(e.target.dataset.id)
        Array.from(active_content.parentNode.children).forEach(x => x.classList.remove('activecontent'))
        active_content.classList.add('activecontent')
    }
    const slideLeft = () => {

    }
    const slideRight = () => {

    }
    const RenderMobileHandlers = () => {
        if (!props.mobileNav){
            return null
        }

        return(
            <>
                <i className="angle left icon" style={{position: 'absolute', left: '-5px', zIndex:"10",  bottom: '8px', fontSize: '20px'}} onClick={slideLeft}/>
                <i className="angle right icon" style={{position: 'absolute', right: '0', zIndex:"10" ,  bottom: '8px', fontSize: '20px'}} onClick={slideRight}/>
            </>
        )
    }
    const renderAddress = (employee) => {
        let fullAddress  = ""
        if (employee.address_1){
            fullAddress += employee.address_1
        }
        if (employee.address_2){
            fullAddress += " "
            fullAddress += employee.address_2
        }
        if (employee.city){
            fullAddress += " "
            fullAddress += employee.city
        }
        if (employee.state){
            fullAddress += " "
            fullAddress += employee.state
        }
        if (employee.pincode){
            fullAddress += " "
            fullAddress += employee.pincode
        }
        return fullAddress
        
    }
    const renderEmployees = props.employees.map(x => {
        return(
            <div className="employee-item" key={x.id}>
                <div className="employee-profile-image"><img src={BASE_URL + x.photo} alt="employee-profile"/></div>
                <div className="employee-profile-detail">
                    <div className="employee-name"><strong>{`@${x.username}` || x.number || x.email}</strong></div>
                    <div className="employee-address">{renderAddress(x)}</div>
                </div>
            </div>
        )
    })
    const renderReviewReply = (replies) => {
        return replies.map(x => {
            return (
                    <CategoryContext.Provider value={category} key={x.id}>
                        <SingleReview key={x.id} review={x} isReply={true} BASEURL={BASE_URL} category={category}/>
                    </CategoryContext.Provider>
            )
        })
    }
    const renderReviews = props.categoryReviews.data.map(x => {
        if (x.parent){
            return null
        }
        return(
            <CategoryContext.Provider value={category} key={x.id}>
                <SingleReview key={x.id} review={x} isReply={false} BASEURL={BASE_URL} renderReviewReply={renderReviewReply} replyActiveFor={replyActiveFor} toggleReply={toggleReplyForm}/>
            </CategoryContext.Provider>
        )
    
    })
    
    
    return(
        <div className="ui container">
          <div className="slider-container" style={{position: 'relative'}}>
                    {RenderMobileHandlers()}
                    <div className="big-service-tabs" ref={scrolableRef}>
                        <div className="tab-item active" onClick={activateTab} data-id="how-it-work">
                            How It Works?
                        </div>
                        <div className="tab-item" onClick={activateTab} data-id={props.serviceCategory.toLowerCase()}>
                            {props.serviceCategory}s
                        </div>
                        <div className="tab-item" onClick={activateTab} data-id="customer-review">
                            Custumer Reviews
                        </div>
                        <div className="tab-item" onClick={activateTab} data-id="faqs">
                            FAQS
                        </div>
                        <div className="tab-item" onClick={activateTab} data-id="about">
                            About {props.serviceCategory}
                        </div>
                </div>
            </div>
            <div className="service-tab-contents">
                <div className="big-service-content activecontent" id="how-it-work">
                    <div className="content-container-one">
                        <h2 className="content-title">How it Works?</h2>
                        <div className="content-item">
                            <img src={currentTheme === "blue" ? image1_blue : image1} alt="service-icon" className="content-image" />
                            <h4>Choose the type of service</h4>
                        </div>
                        <div className="content-item">
                            <img src={currentTheme === "blue" ? image2_blue : image2} alt="service-icon" className="content-image" />
                            <h4>Choose the time-slot</h4>
                        </div>
                        <div className="content-item">
                            <img src={currentTheme === "blue" ? image3_blue : image3} alt="service-icon" className="content-image" />
                            <h4>Hassle-free service</h4>
                        </div>
                    </div>
                </div>
                <div className="big-service-content" id={props.serviceCategory.toLowerCase()}>
                    <div className="content-container-two">
                        <h2 className="content-title">{props.serviceCategory}s</h2>
                        <div className="employee-list-container">
                            {renderEmployees}
                        </div>
                    </div>
                </div>
                <div className="big-service-content" id="customer-review">
                    <div className="content-container-three">
                        <div className="ui comments">
                            <h2 className="ui dividing header content-title">Customers Reviews</h2>
                            {renderReviews}
                        </div>
                        <div className="create-review">
                            {props.authenticated ? <CategoryContext.Provider value={category}>
                                <CreateReview />
                            </CategoryContext.Provider> : <h2 style={{textAlign: 'center'}}><Link to="/login">Login</Link> to add reviews or reply to reviews</h2>}
                        </div>
                    </div>
                </div>
                <div className="big-service-content" id="faqs">
                    <div className="content-container-four">
                        <h2 className="content-title">Faqs</h2>
                        <div>
                            <Accordian items={props.accordianItem}/>
                        </div>
                    </div>
                </div>
                <div className="big-service-content" id="about">
                    <div className="content-container-five">
                        <h2 className="content-title">About {props.serviceCategory}</h2>
                        <div>
                            <h3>{props.about.title}</h3>
                            <p dangerouslySetInnerHTML={{__html: props.about.desc}}></p>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav: state.mobileNav,
        employees: state.employees, 
        categoryReviews: state.categoryReview,
        authenticated: state.Authentication.loginStatus,
        currentTheme: state.theme
    }
}
export default connect(mapStateToProps, { fetchEmployees, fetchCategoryReviews })(BigServiceTab)

